module.exports = __webpack_public_path__ + "img/load-1-2.62b9c464.png";